module.exports = __webpack_public_path__ + "banner02.jpg?ce932a33eaa948ae758886f81d189359";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner02.jpg
// module id = 62
// module chunks = 0